var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.records,
            border: "",
            size: "mini",
            "element-loading-text": "正在加载中～",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "类型",
              prop: "type",
              align: "center",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "发送时间", prop: "createTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "发送状态",
              prop: "state",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "手机号/openId/邮箱",
              prop: "mobile",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "信息标题", prop: "title", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "信息内容", prop: "text", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top-start" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tooltip-content",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [_vm._v(_vm._s(row.text))]
                        ),
                        _c("div", { staticClass: "tooltip-trigger" }, [
                          _vm._v(_vm._s(row.text)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "right",
            "margin-right": "20px",
            "margin-top": "20px",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.paginationObj.current,
              "page-size": _vm.paginationObj.size,
              background: "",
              layout: "prev, pager, next",
              total: _vm.total,
              size: "mini",
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }